import axiosInstance from "../Axios/axiosInstance";

const getAllInsurances = async () => {
  return await axiosInstance.get("/carInsurances/");
};

const getInsuranceById = async (id) => {
  return await axiosInstance.get(`/carInsurances/${id}`);
};

const addInsurance = async (data) => {
  console.log(data);
  return await axiosInstance.post("/carInsurances/", data);
};

const editInsurance = async (id, data) => {
  return await axiosInstance.put(`/carInsurances/${id}`, data);
};

const deleteInsurance = async (id) => {
  return await axiosInstance.delete(`/carInsurances/${id}`);
};

export default {
  getAllInsurances,
  getInsuranceById,
  addInsurance,
  editInsurance,
  deleteInsurance,
};
